module.exports = {"single":"single-app-377690.js"}


/** WEBPACK FOOTER **
 ** ./Scripts/aem/app.js
 **/